import type { IInitialLanguageSelectProps } from "../../types";
import { Box, Button } from "@mui/material";

export default function InitialLanguageSelect(props: IInitialLanguageSelectProps) {
  const { languages, styles, handleInitialLanguageSelect } = props;

  return (
    <Box sx={styles.initial}>
      <Box sx={styles.languageBox}>
        {languages.map((language, i) => (
          <Button
            sx={styles.button}
            variant="outlined"
            key={language.language + i}
            onClick={() => handleInitialLanguageSelect(language.language)}
            id={language.language}
          >
            {language.display}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
